import { useState } from 'react';
import { Outlet } from 'react-router';
import { SkipLink } from './SkipLink';
import { SideNav } from './SideNav';
import { MobileTopBar } from './MobileTopBar';
import { NavDrawer } from './NavDrawer';
import { RouteFocus } from './RouteFocus';
import s from './AppShell.module.css';

export function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={s.shell}>
      <SkipLink />

      <div className={s.topBar}>
        <MobileTopBar onOpenMenu={() => setMenuOpen(true)} />
      </div>
      <NavDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />

      <div className={s.sidebar}>
        <SideNav />
      </div>

      {/* tabIndex -1 so RouteFocus can move focus here; see RouteFocus for why it must. */}
      <main id="main" className={s.main} tabIndex={-1}>
        <div className={s.page}>
          <Outlet />
        </div>
      </main>

      <RouteFocus />
    </div>
  );
}

export default AppShell;
